module.exports = __webpack_public_path__ + "static/media/icon_network_43114.d2512f9d.png";